import sileo from 'sileo';

const RecruitmentNotes = new sileo.Model('bposeats', 'recruitment-notes');

const actions = {
    createRecruitmentNote(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return RecruitmentNotes.objects.create(form);
    },

    fetchRecruitmentNote(context, filter) {
        return RecruitmentNotes.objects.filter(filter);
    },
};

export default {
    namespaced: true,
    actions,
};
